module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"header1":"Om oss","text":"Nasjonalt bålplassregister er utviklet av Mjøs gruppen"}}')
  delete Component.options._Ctor
}
